import { createRequest, RequestConfig } from 'app/common/api';

import { TTripConstraints } from '../core/trip-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_trips',
};

export const getTripsRequest = (constraints?: TTripConstraints) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
